import React from 'react';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import CurrencyFormatInput from '../../commonComponents/util/CurrencyFormatInput';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import { ApplicationStatuses, CurrencyTypes } from '../../../lib/systemVariables';
import { formatCurrency, formatDateForInput, getObjectKeyByValue } from '../../../lib/utils';

const initialState = props => ({
    showDropdown: false,
    showApprove: false,
    showReject: false,
    showReview: false,
    showMarkForInquiry: false,
    amount: props.amount || '',
    approvalNote: '',
    rejectReason: '',
    reviewDate: '',
    inquire: props.inquire,
    inquireNote: props.inquireNote || '',
    updateAttempted: false,
    updateError: false
});

export default class ApplicationActionsDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = initialState(props);

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentWillMount() {
        if (this.props.amount) {
            this.setState({ amount: this.props.amount });
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
      }
    
      componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
      }

    toggleDropdown(dropdownPart) {
        if (this.props.locked) return;

        this.setState({
            ...initialState(this.props),
            showDropdown: true,
            [dropdownPart]: !this.state[dropdownPart]
        });
    }

    onChange(name, value) {
        this.setState({ [name]: value });
    }

    async updateStatus(action, applications) {
        if (this.props.locked) return;

        this.setState({ updateAttempted: true, updateError: false });

        if (action === "approve" && this.state.amount > this.props.maxAmount) return;

        await this.props.updateApplicationStatus(action, applications);
        if (!this.props.update.success)
            this.setState({ updateError: true });
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
      }

      handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.showDropdown) {
            this.setState({...initialState(this.props)})
        }
      }

    render() {
        return (
            <div className="custom-dropdown" ref={this.setWrapperRef}>
                <button
                    className={`btn btn-flat btn-flat-status-${this.props.status ? this.props.status.replace(' ', '').toLowerCase() : ''}`}
                    disabled={this.props.disabled}
                    aria-disabled={this.props.locked}
                    onClick={this.toggleDropdown.bind(this, 'showDropdown')}>
                    {this.props.status} <i className={`"icon icon-right ion-android-arrow-drop${this.state.showDropdown ? "up" : "down"}`}></i>
                </button>
                <div hidden={!this.state.showDropdown} className="custom-dropdown-box">
                    {(this.props.status === ApplicationStatuses.InReview || this.props.status === ApplicationStatuses.New) &&
                        <div className="custom-dropdown-option">
                            <div className="flex-justify" onClick={this.toggleDropdown.bind(this, 'showApprove')}>
                                <p className="medium-text">Approve</p>
                                <i className={`icon ion-ios-arrow-${this.state.showApprove ? "up" : "down"}`}></i>
                            </div>
                            {this.state.showApprove && <div className="custom-dropdown-extension flex-wrap">
                                <ValidatedInput input={<CurrencyFormatInput className="input" placeholder="Amount" isIsraeli={this.props.currency === CurrencyTypes.Shekel} />}
                                    name="amount" value={this.state.amount} onChange={this.onChange.bind(this)}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' && this.state.amount)
                                            this.updateStatus('approve', [{
                                                applicationId: this.props.applicationId,
                                                amount: this.state.amount,
                                                currency: getObjectKeyByValue(CurrencyTypes, this.props.currency),
                                                approvalNote: this.state.approvalNote
                                            }])
                                    }}
                                    validated={true} showValidationError={this.state.updateAttempted}
                                    validate={val => this.props.maxAmount ? this.state.amount <= this.props.maxAmount : true}
                                    errorMessage={`Amount cannot exceed ${formatCurrency(this.props.maxAmount, this.props.currency === CurrencyTypes.Shekel)}.`} />
                                <input type="text" placeholder="Approval Note" name="approvalNote" value={this.state.approvalNote}
                                    onChange={e => this.onChange(e.target.name, e.target.value)}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' && this.state.amount)
                                            this.updateStatus('approve', [{
                                                applicationId: this.props.applicationId,
                                                amount: this.state.amount,
                                                currency: getObjectKeyByValue(CurrencyTypes, this.props.currency),
                                                approvalNote: this.state.approvalNote
                                            }])
                                    }} />
                                {this.props.update.loading ? <LoadingSpinner height="16" />
                                    : <button className="btn btn-flat btn-flat-primary btn-flat-primary-background" disabled={!this.state.amount}
                                        onClick={this.updateStatus.bind(this, 'approve', [{
                                            applicationId: this.props.applicationId,
                                            amount: this.state.amount,
                                            currency: getObjectKeyByValue(CurrencyTypes, this.props.currency),
                                            approvalNote: this.state.approvalNote
                                        }])}>
                                        <i className="material-icons icon-left">save</i>Save
                                </button>}
                                <FadeOutErrorMessage show={this.state.updateError} />
                            </div>}
                        </div>
                    }
                    {(this.props.status === ApplicationStatuses.InReview || this.props.status === ApplicationStatuses.New) && 
                        <div className="custom-dropdown-option">
                            <div className="flex-justify" onClick={this.toggleDropdown.bind(this, 'showReject')}>
                                <p className="medium-text">Reject</p>
                                <i className={`icon ion-ios-arrow-${this.state.showReject ? "up" : "down"}`}></i>
                            </div>
                            {this.state.showReject && <div className="custom-dropdown-extension">
                                <input type="text" placeholder="Reason" name="rejectReason" value={this.state.rejectReason}
                                    onChange={e => this.onChange(e.target.name, e.target.value)}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter')
                                            this.updateStatus.bind(this, 'reject', [{ applicationId: this.props.applicationId, rejectReason: this.state.rejectReason }])
                                    }} />
                                {this.props.update.loading ? <LoadingSpinner height="16" />
                                    : <button className="btn btn-flat btn-flat-primary btn-flat-primary-background"
                                        onClick={this.updateStatus.bind(this, 'reject', [{ applicationId: this.props.applicationId, rejectReason: this.state.rejectReason }])}>
                                        <i className="material-icons icon-left">save</i>Save
                                </button>}
                                <FadeOutErrorMessage show={this.state.updateError} />
                            </div>}
                        </div>
                    }
                    {this.props.status === ApplicationStatuses.New && <div className="custom-dropdown-option">
                        <div className="flex-justify" onClick={this.toggleDropdown.bind(this, 'showReview')}>
                            <p className="medium-text">Review</p>
                            <i className={`icon ion-ios-arrow-${this.state.showReview ? "up" : "down"}`}></i>
                        </div>
                        {this.state.showReview && <div className="custom-dropdown-extension">
                            <input type="date" name="reviewDate" value={this.state.reviewDate} max="9999-12-31"
                                onChange={e => this.onChange(e.target.name, e.target.value)}
                                min={formatDateForInput(new Date().setDate(new Date().getDate() + 1))} />
                            {this.props.update.loading ? <LoadingSpinner height="16" />
                                : <button className="btn btn-flat btn-flat-primary btn-flat-primary-background" disabled={!this.state.reviewDate || (new Date(this.state.reviewDate) <= Date.now())}
                                    onClick={this.updateStatus.bind(this, 'review', [{ applicationId: this.props.applicationId, reviewDate: this.state.reviewDate }])}>
                                    <i className="material-icons icon-left">save</i>Save
                            </button>}
                            <FadeOutErrorMessage show={this.state.updateError} />
                        </div>}
                    </div>}
                    {((this.props.userId === this.props.approverId || this.props.admin)) && <div className="custom-dropdown-option">
                        <div className="flex-justify" onClick={this.toggleDropdown.bind(this, 'showMarkForInquiry')}>
                            <p className="medium-text">{this.props.inquire ? 'Edit Inquiry' : 'Mark For Inquiry'}</p>
                            <i className={`icon ion-ios-arrow-${this.state.showMarkForInquiry ? "up" : "down"}`}></i>
                        </div>
                        {this.state.showMarkForInquiry && <div className="custom-dropdown-extension flex-wrap">
                            <div className="custom-check-container">
                                <input type="checkbox" id="inquire" name="inquire" className="custom-check"
                                    checked={this.state.inquire}
                                    onChange={e => this.onChange(e.target.name, e.target.checked)}/>
                                <label htmlFor="inquire">Mark this application for inquiry</label>
                            </div>
                            {this.state.inquire &&<input type="text" placeholder="Note" name="inquireNote" value={this.state.inquireNote}
                                onChange={e => this.onChange(e.target.name, e.target.value)}
                                onKeyDown={e => {
                                    if (e.key === 'Enter')
                                        this.updateStatus.bind(this, 'markForInquiry', 
                                            [{ applicationId: this.props.applicationId, inquire: this.state.inquire, inquireNote: this.state.inquireNote }])
                                }} />}
                            {this.props.update.loading ? <LoadingSpinner height="16" />
                                : <button className="btn btn-flat btn-flat-primary btn-flat-primary-background"
                                    onClick={
                                        this.updateStatus.bind(this, 'markForInquiry', 
                                            [{ applicationId: this.props.applicationId, inquire: this.state.inquire, inquireNote: this.state.inquireNote }])}>
                                    <i className="material-icons icon-left">save</i>Save
                            </button>}
                            <FadeOutErrorMessage show={this.state.updateError} />
                        </div>}
                    </div>}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/ApplicationActionsDropdown.jsx